module.exports = __webpack_public_path__ + "img/ho-annan.42c63a6a.jpg";